import { FC, useMemo } from 'react'
import clsx from 'clsx'
import { IIconTagArray, paddingTopClassMap, paddingBottomClassMap } from '@common/pd-meta-components-types'
import TagItem from '@/components/standard/tag-item'
import { useMobileDetector } from '@/hooks/use-mobile-detector'

interface IClassNameForType {
  title: string
  box: string
  itemIcon: string
  itemTitle: string
  contentAlign: 'left' | 'center'
}

const PdMetaIconTagArray: FC<IIconTagArray> = ({ theme, title, dataList, type, align = 'center', paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const isMobile = useMobileDetector()
  const classNameForType = useMemo<IClassNameForType>(() => {
    switch (type) {
      case 'F7-4':
        return {
          title: 'text-center',
          box: 'grid grid-cols-2 laptop:grid-cols-4',
          contentAlign: 'center',
          itemIcon: 'w-12 h-12 laptop:w-20 laptop:h-20',
          itemTitle: 'pd-third-title',
        }
      case 'F7-3':
        return {
          title: 'text-center',
          box: 'grid grid-cols-2 laptop:grid-cols-3',
          contentAlign: 'center',
          itemIcon: 'w-12 h-12 laptop:w-20 laptop:h-20',
          itemTitle: 'pd-first-title',
        }
      case 'F7-2':
        return {
          title: 'text-center',
          box: 'grid grid-cols-2 laptop:grid-cols-3',
          contentAlign: 'center',
          itemIcon: 'w-12 h-12 laptop:w-20 laptop:h-20',
          itemTitle: 'pd-third-title',
        }
      case 'F7-1':
      default:
        return {
          title: 'text-start',
          box: 'grid grid-cols-2 laptop:grid-cols-4',
          contentAlign: 'left',
          itemIcon: 'w-12 h-12 laptop:w-14 laptop:h-14',
          itemTitle: 'pd-third-title',
        }
    }
  }, [type])

  return (
    <div className={clsx(`w-full h-fit pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full mx-auto px-6 flex flex-col', 'laptop:max-w-300 laptop:px-0', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom])}>
        {title && (
          <h2
            className={clsx(
              'font-semibold mb-8 laptop:mb-64px',
              'text-fc-primary pd-first-title',
              classNameForType.title
            )}
          >
            {title}
          </h2>
        )}
        {!!dataList?.length && (
          <div className={clsx('gap-y-6 gap-x-3 laptop:gap-y-12 laptop:gap-x-6', classNameForType.box)}>
            {dataList?.map((item) => (
              <TagItem
                key={item.title}
                mediaUrl={item.mediaUrl}
                title={item.title}
                desc={item.desc}
                contentAlign={isMobile ? 'left' : classNameForType.contentAlign}
                iconAlign={align}
                mediaClassName={classNameForType.itemIcon}
                titleClassName={classNameForType.itemTitle}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PdMetaIconTagArray
